export const initialState = {
    is_loading: true,
    total_recall_visits: 0,
    total_pages: 0,
    current_page: 1,
    recall_visits: [],
    search_value: "",
    sort_key: '',
    sort_direction: ''
}